import { client } from '@/client';

// 获取菜单数据
export function getMenuList() {
  return client.get('/api/menu/queryTree');
}

// 更新菜单
export function updateMenu(params) {
  return client.post('/api/menu/update', params);
}

// 新增菜单
export function createMenu(params) {
  return client.post('/api/menu/add', params);
}

// 删除菜单
export function deleteMenu(id) {
  return client.delete(`/api/menu/delete/${id}`);
}
